<div class="wrap">

  <div class="loading" *ngIf="loading">
    <mat-spinner [diameter]="100" [color]="color"></mat-spinner>
  </div>
  <div class="header">
    <div class="title">
      <fa-icon [icon]="faChevronLeft" [routerLink]="['/smartparking/cameras']" routerLinkActive="router-link-active">
      </fa-icon>
      <h1>Places de parking - {{nameCamera}}</h1>
    </div>
    <div class="edit_and_search">
      <div class="edit" [routerLink]="['/smartparking/cameras/update']" routerLinkActive="router-link-active"
        [queryParams]="{name: nameCamera, id:idCamera}" (mouseenter)="showElement()" (mouseleave)="show = false">
        <fa-icon [icon]="faPen" class="faPen"></fa-icon>
        <div class="show_after_hover" *ngIf="show">
          <span>Modifier</span>
        </div>
      </div>
      <div class="search_bar">
        <input type="text" placeholder="Chercher une place de parking ..." (input)="applyFilter($event.target.value)">

        <!-- <fa-icon [icon]=" faTimes" (click)="resetSearch($event)"></fa-icon> -->

        <fa-icon [icon]=" faSearch"></fa-icon>
      </div>
    </div>
  </div>

  <div class="stat">
    <div class="infos_parking">
      <div class="overview">
        <!-- <img src="assets/img/parking-demo.png" alt="parking"> -->
        <div class="overview_parking">
          <div *ngFor="let p of parking; let i = index"
            [ngClass]="{free: timeIsExceeded(p.statusTime, p.status) === 'Free', occuped: timeIsExceeded(p.statusTime, p.status) === 'Occupied', time_exceeded: timeIsExceeded(p.statusTime, p.status) === 'timeExceeded'}"
            [style.margin-right.%]="i ===22 ? 8 : 0" [style.margin-bottom.px]="i>11? 0: 40">
            {{getNameSlot(p.name)}}</div>
        </div>
        <div class='legend'>
          <div class="place_free">
            <span></span>
            <p>Libre</p>
          </div>
          <div class="place_occuped">
            <span></span>
            <p>Occupée</p>
          </div>
          <div class="place_time_exceeded" *ngIf="isAdmin">
            <span></span>
            <p>Temps dépassé</p>
          </div>
        </div>
      </div>
      <div class="infos_parking_content">
        <div class="infos_parking_content_title">
          <h4>Infos sur le parking </h4>
          <fa-icon [icon]="faSyncAlt" (click)="refreshInfoParking()"></fa-icon>
        </div>
        <div class="infos_parking_content_details">
          <p>Nombre de places: <strong>{{parking?.length}}</strong></p>
          <p>Nombre de places disponibles: <strong>{{placeFree}}</strong></p>
          <p>Nombre de places occupées: <strong>{{placeOccupied}}</strong></p>
          <p>Temps dépassé: <strong>{{numbCarsTimeLimitExceeded}}</strong></p>
          <p>Total de voitures en dépassement le <i><strong>{{today | date:'mediumDate' }}</strong></i>:
            <strong>{{numberOfCarSuctionCup}}</strong>
          </p>
        </div>

        <div class="btn_action">
          <a    href="https://pz1.phoenix-ai.com/snapshot" target="_blank" [style.margin-right.px]="5">
            <button>
            <!-- <button data-href="https://pz1.phoenix-ai.com/snapshot"  (click)="goToUrl($event)"> -->
              <fa-icon [icon]="faEye"></fa-icon>
              Aperçu
            </button>
          </a>
          <!-- <a href="https://pz1.phoenix-ai.com/live" target="_blank" [style.margin-left.px]="5">
            <button>
              <fa-icon [icon]="faVideo"></fa-icon>
              Live
            </button>
          </a> -->
        </div>

        <!-- <div class="img">
              <img src="https://pz1.phoenix-ai.com/snapshot" alt="parking" (click)="openDialogPreviewParking()">
            </div> -->
      </div>
    </div>
  </div>

  <div class="container">
    <app-smartparking-slots-table></app-smartparking-slots-table>
  </div>

</div>